import React, { Component } from 'react';
import firebase, { auth } from './firebase.js';
import Photo from './Photo';
import './Feed.css';

class Feed extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: [],
			fetching: false,
			initialLoad: false
		}
	}

	componentDidMount() {
		const itemsRef = firebase.database().ref(this.props.path);
		itemsRef.orderByKey().limitToLast(25).once('value', (snapshot) => {
			let items = snapshot.val();
			let newState = [];
			for (let item in items) {
				newState.push({
					id: item,
					url: items[item].url,
					time: items[item].time,
					fullSizeUrl: items[item].fullSizeUrl,
					uid: items[item].uid,
					name: items[item].name,
					isFeatured: items[item].isFeatured
				});
			}

			let newestState = newState.reverse();
			let lastImage = newestState[newestState.length -1];

			this.setState({
				lastImage: lastImage !== undefined ? lastImage.id : null,
				items: newestState
			});

			if (newestState === undefined || newestState.length == 0) { return }

			itemsRef.orderByKey().startAt(newestState[0].id).on("child_added", (snapshot, prevChildKey) => {
				if(snapshot.key === newestState[0].id) { return; }
				var index = this.state.items.map(function(x) {return x.id; }).indexOf(prevChildKey);
				let item = snapshot.val();
				let values = {
					id: snapshot.key,
					url: item.url,
					time: item.time,
					fullSizeUrl: item.fullSizeUrl,
					uid: item.uid,
					name: item.name,
					isFeatured: item.isFeatured
				}

				let items = this.state.items;
				items.splice(index >= 0 ? index : 0, 0, values);

				this.setState({
					items: items
				});
			});

			itemsRef.on("child_changed", (snapshot) => {
				let items = this.state.items;
				let object = items.find(obj => { return obj.id === snapshot.key });
				let item = snapshot.val();
				let values = {
					id: snapshot.key,
					url: item.url,
					time: item.time,
					fullSizeUrl: item.fullSizeUrl,
					uid: item.uid,
					name: item.name,
					isFeatured: item.isFeatured
				}
				if (object) {
					Object.assign(object, values);
					this.setState({
						items: items
					});
				}
			});

			itemsRef.on("child_removed", (snapshot) => {
				let filteredArray = this.state.items.filter(obj => { return obj.id !== snapshot.key });
				this.setState({
					items: filteredArray
				});
			});

			clearInterval(this.state.intervalId);
			let intervalId = setInterval(this.prefill, 1000);
			this.setState({
				intervalId: intervalId,
				initialLoad: true
			});
		});

		auth.onAuthStateChanged((user) => {
		    if (user) {
		    	this.setState({
					isCurrentUser: (user.uid === this.props.uid)
				});
		    }
	  	});

	  	window.addEventListener('scroll', this.handleScroll);
	  	window.addEventListener('resize', this.prefill);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.prefill);
		this.setState({
			lastImage: null,
			items: []
		});
	}

	prefill = (e) => {
		let documentHeight = document.documentElement.offsetHeight;
		let windowHeight = window.innerHeight;
		if (documentHeight < windowHeight &&
			this.state.fetching === false &&
			this.state.lastImage !== null) {
			this.fetchPhotos();
		} else {
			clearInterval(this.state.intervalId);
		}
	}

	handleScroll = (e) => {
		let supportPageOffset = window.pageXOffset !== undefined;
		let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
		let documentHeight = document.documentElement.offsetHeight;
		let scrollPosition = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
		let windowHeight = window.innerHeight;
		if ((windowHeight + scrollPosition >= documentHeight) &&
			this.state.lastImage &&
			this.state.fetching === false) {
			this.fetchPhotos();
		}
	}

	fetchPhotos = (e) => {
		this.setState({
			fetching: true
		});
		const itemsRef = firebase.database().ref(this.props.path)
			.orderByKey()
			.endAt(this.state.lastImage)
			.limitToLast(16);
		itemsRef.once('value', (snapshot) => {
			let newState = [];
			let items = snapshot.val();
			for (let item in items) {
				newState.push({
					id: item,
					url: items[item].url,
					time: items[item].time,
					fullSizeUrl: items[item].fullSizeUrl,
					uid: items[item].uid,
					name: items[item].name,
					isFeatured: items[item].isFeatured
				});
			}

			newState.pop();
			if (newState.length === 0) {
				clearInterval(this.state.intervalId);
			}
			let newestState = this.state.items.concat(newState.reverse());
			this.setState({
				lastImage: newestState[newestState.length -1].id,
				items: newestState,
				fetching: false
			});
		});
	}

	render() {
		return (
			<ul id="feed" ref="feed">
			{this.state.items.map((item) => {
				return (
					<Photo
						key={item.id}
						alt={item.time}
						url={item.url ? item.url : item.fullSizeUrl }
						fullSizeUrl={item.fullSizeUrl ? item.fullSizeUrl : item.url}
						id={item.id}
						uid={item.uid ? item.uid : this.props.uid}
						name={item.name}
						isFeatured={item.isFeatured}
						isProfile={this.props.isProfile}
						delete={this.state.isCurrentUser ? true : false }
						admin={this.props.admin}
					/>
				)
			})}
			</ul>
		);
	}
}

export default Feed;


// WEBPACK FOOTER //
// ./src/Feed.js